module.exports = __webpack_public_path__ + "02_short_yellow.897775ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_short_yellow.png
// module id = +8gU
// module chunks = 0